<template>
    <div class="font-opensans vs-page">
      <div class="card shadow-sm vs-filter-card">
        <div class="vs-header">
          <div class="vs-header-title">
            <b-icon icon="bag-check" font-scale="1.1"></b-icon>
            <span>Vista de Productos</span>
          </div>
          <div class="vs-header-actions">
            <b-button v-if="!cargando" :hidden="ocultarnuevo" class="vs-action-btn" @click="nuevoProducto()">
              <b-icon icon="plus-circle"></b-icon> Nuevo
            </b-button>
          </div>
        </div>
        <div class="vs-filters">
          <b-input-group size="sm">
            <b-form-input v-model="filter" type="search" placeholder="Escribe para filtrar"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''" class="vs-clear-btn">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
            aria-controls="my-table" size="sm" pills align="center" class="mt-2">
          </b-pagination>
        </div>
      </div>
      <div class="card shadow-sm mt-3 vs-data-card">
        <b-table v-if="!cargando" hover small :items="productos" :fields="fields" selectable responsive striped
                caption-top :filter="filter" select-mode="single" :per-page="perPage"
                :current-page="currentPage" label-sort-asc="" label-sort-desc="" label-sort-clear=""
                style="font-size:12px;" table-class="custom-table" thead-class="table-header" tbody-class="table-body">
          <template #table-caption><strong class="fcgreen">Productos: {{ productos.length }}</strong></template>
          <template #cell(edit)="data">
            <b-button size="sm" variant="outline-dark" @click="editarProducto(data.item)">Editar</b-button>
          </template>
        </b-table>
        <b-spinner v-else class="text-center" variant="warning"></b-spinner>
      </div>
      <Modals ref="mod"></Modals>
    </div>
</template>
<script>
import Modals from '@/components/Modals.vue'
// import productos from '@/catalogos/productos.vue'
import {mapState,mapActions} from 'vuex'
import * as utils from "@/shared/util"

export default {
    data() {
        return {
            texto: 'Productos',
            currentPage:1,
            perPage:20,
            fields:[{key: 'producto_id', label: 'operador_id', class:"d-none"},
                    {key: 'clave', label: 'Clave', class:"negritas"},
                    {key: 'descripcion', label: 'Nombre', sortable: true},
                    {key: 'tipo_producto_id', label: 'tipo_id', sortable: true, class:'d-none'},
                    {key: 'tipo', label: 'Tipo', sortable: true},
                    {key: 'estatus', label: 'Estatus', sortable: true, class:'negritas'},
                    {key: 'fecha_hora_creacion', label: 'Creado', sortable: true, class:'negritas'},
                    {key: 'fecha_hora_modif', label: 'Modificado', sortable: true, class:'negritas'},
                    {key: 'edit', label: 'Editar', sortable: true},
                    // {key: 'DIFERENCIA', label: 'DIF', class:'negritas'},
                    ],
            productos:[],
            tipos_productos:[],
            filter:'',
            cargando:false,
        }
    },
    components: {
        Modals,
        // productos,
    },
    computed: {
        ...mapState(['operador','modal','menu']),
        rows() {
            return this.productos.length
        },
        ocultarnuevo(){
            // if(this.tabselected==0 ){
            //     return true
            // }else{
                return false
            // }
        },
    },
    created () {
        // let f=Date();
        //  this.ffin= utils.getDateTime(f)
        //  this.fini=this.ffin
       //console.warn("la ruta: " + this.$route.name)
        this.getproductos()
    },
    methods: {
        ...mapActions(['actupdateMenu','actupdateModal']),
        showmodal(tittle,message){
            this.modal.tittle = tittle
            this.modal.message = message
            this.modal.type = 0
            this.actupdateModal(this.modal)
            // console.log("ahora contiene:  " + JSON.stringify(this.modal))
            this.$refs.mod.showmodal()
        },
        getproductos() {
            this.cargando=true
           
            this.$store.dispatch("getProductos").then((resp)=>{
               //console.log("La respuesta de getProductos: " + JSON.stringify(resp))
                if(resp.estatus == 1){
                    this.productos=resp.productos
                    this.cargando=false
                }else{
                    this.showmodal(this.texto, resp.message)
                    this.cargando=false
                }
            }).catch((err)=>{
                this.showmodal(this.texto, err)
                this.cargando=false
            })
        },
        nuevoProducto(){
            // this.$router.push({ name: 'productos' });
            if (this.$route.name !== 'productos') {
                this.$store.dispatch('actupdateMenu',{ruta:'productos', tittle:'Productos'}).then(()=>{ 
                   //console.warn("la ruta: " + this.$route.name)
                    this.$router.push({ name: 'productos' });
                })
            }
          
        },
        editarProducto(data){
            // this.$router.push({ name: 'productos' });
           //console.warn("la ruta: " + this.$route.name)
            if (this.$route.name !== 'productos') {
                this.$router.push({ name: 'productos', params: data});
            }

            // console.log("edindo perador")
            // this.$router.push({ name: 'operadores', params: item});
        },
        imprimir(){
            //  console.log("EL tabselected: " + this.tabselected)
            //  if(this.tabselected===0){ 
            //      utils.exportar(this.renglonaje,'renglonaje')
            //  }else if(this.tabselected===1){
            utils.exportar(this.productos,'Clientes distribidor')
            //  }
         },
    },
}
</script>

<style scoped>
@import "@/assets/css/app.css";
</style>
